import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { SupportUser } from '../model/support.model';
import { Observable, from, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  authUserUid: string;

  user: Observable<any | null>;

  constructor(private afs: AngularFirestore, private afAuth: AngularFireAuth) {
    this.user = this.afAuth.authState.pipe(
      switchMap((user) => {
        if (user) {
          return this.afs.doc(`users/${user.uid}`).valueChanges();
        } else {
          return of(null);
        }
      })
    );
  }

  public addSupportUser(support: SupportUser): Observable<any> {
    return from(this.afs.collection(`support`).add({ ...support })).pipe(
      map((action) => {
        return action.id;
      })
    );
  }
}
